/**
 * Конфигурация прожекторов
 * Централизованное хранилище всех настроек, путей к моделям и коэффициентов
 */

export const PROJECTOR_CONFIG = {
    // Модель для СЦЕНЫ: оптимизированная (текстура 1024², FrontSide) — при
    // размере прожектора в сцене отличий не видно, а VRAM в 16 раз меньше.
    MODEL_PATH: '/models/projectors/projector.glb',
    // НЕТРОНУТЫЙ оригинал (текстура 4096², doubleSided) — ТОЛЬКО stage-крупный
    // план: на уменьшенном атласе там видны протечки цвета между UV-островами.
    MODEL_PATH_HQ: '/models/projectors/projector-hq.glb',
    /** Верхний предел инстансов после батча (производительность). При обрезке — пропорционально по стенам. */
    MAX_INSTANCES: 160,
    BASE_SCALE: [0.2, 0.2, 0.2],

    // Позиция текста (если используется внутри модели)
    TEXT: {
        POSITION: [0, 0.4, 0],
        FONT_SIZE: 0.1
    },

    // Параметры позиционирования
    POSITIONING: {
        INSTALLATION_DEPTH: 0.6,
        BASE_SCALE: [0.2, 0.2, 0.2],
        MIN_SCALE_FACTOR: 0.3,
        REF_DEPTH: 1.6,
        REF_LENGTH: 5.0,
        REF_WIDTH: 3.5,
        WALL_OFFSET: 0
    }
};

export const getProjectorModelPath = () => PROJECTOR_CONFIG.MODEL_PATH;

/**
 * Получить масштаб прожектора в зависимости от размеров бассейна
 * @param {number} depth 
 * @param {number} length 
 * @param {number} width 
 */
export const getProjectorScale = (depth = null, length = null, width = null) => {
    const {
        BASE_SCALE,
        MIN_SCALE_FACTOR,
        REF_DEPTH,
        REF_LENGTH,
        REF_WIDTH
    } = PROJECTOR_CONFIG.POSITIONING;

    let depthScale = 1.0;
    let lengthScale = 1.0;
    let widthScale = 1.0;

    if (depth !== null && depth < REF_DEPTH) {
        depthScale = MIN_SCALE_FACTOR + (1 - MIN_SCALE_FACTOR) * (depth / REF_DEPTH);
    }
    if (length !== null && length < REF_LENGTH) {
        lengthScale = MIN_SCALE_FACTOR + (1 - MIN_SCALE_FACTOR) * (length / REF_LENGTH);
    }
    if (width !== null && width < REF_WIDTH) {
        widthScale = MIN_SCALE_FACTOR + (1 - MIN_SCALE_FACTOR) * (width / REF_WIDTH);
    }
    // Для боковых прожекторов критичнее узкая сторона и малая глубина.
    const sideFactor = Math.min(lengthScale, widthScale);
    const finalFactor = Math.min(depthScale, sideFactor);

    return [
        BASE_SCALE[0] * finalFactor,
        BASE_SCALE[1] * finalFactor,
        BASE_SCALE[2] * finalFactor
    ];
};


